var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.$t('we have sent you a confirmation email at'))+"\n  "),_c('strong',[_vm._v(_vm._s(_vm.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }